import * as React from "react";
import { forwardRef } from "react";
const SvgIconAppointmentNoshow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18.004, height: 18, viewBox: "0 0 18.004 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { "data-name": "icon/noshow" }, /* @__PURE__ */ React.createElement("path", { d: "M12 3a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9m0 1.385a7.612 7.612 0 0 1 5.8 12.548L7.176 6.094A7.6 7.6 0 0 1 12 4.385M6.2 7.067l10.627 10.839A7.62 7.62 0 0 1 6.2 7.067", "data-name": "Path 11346", transform: "translate(-3 -3)", fill: "#98a9bc" })));
const ForwardRef = forwardRef(SvgIconAppointmentNoshow);
export { ForwardRef as ReactComponent };
